<template>
  <div>
    <!-- 审核历史 -->
    <el-collapse v-model="activeNames" class="collapse-box">
      <el-collapse-item class="collapseItem1" title="审核历史" name="1">
        <el-tabs type="border-card" stretch>
          <el-tab-pane label="核销审核历史">
            <div>
              <div class="table">
                <el-table :data="writeoffTaskData" border stripe>
                  <el-table-column prop="displayName" label="审核节点" />
                  <el-table-column prop="operatorName" label="审核人" />
                  <el-table-column prop="finishTime" label="审核时间" />
                  <!-- <el-table-column prop="amounts" label="申请费用(元)" align="right">
                    <template slot-scope="scope">
                      <span v-if="scope.row.amounts">{{ scope.row.amounts | toThousandNumFilter }}</span>
                    </template>
                  </el-table-column> -->
                  <!-- <el-table-column prop="approveCost" label="审核费用(元)" >
                    <template slot-scope="scope">
                      <span v-if="scope.row.approveCost">{{ scope.row.approveCost | toThousandNumFilter }}</span>
                    </template>
                  </el-table-column> -->

                  <el-table-column prop="approveCost" label="审核费用(元)">
                    <template slot-scope="scope">
                      <span v-if="scope.row.approveCost && scope.row.operateType !== '驳回' ">
                        {{ scope.row.approveCost | toThousandNumFilter }}
                      </span>
                    </template>
                  </el-table-column>

                  <!-- <el-table-column prop="approveCost" label="审核费用(元)">
                    <template slot-scope="scope">
                      <span v-if="scope.$index === 0 && signData && signData.actualCost && activity && activity.writeRate">
                        {{ (signData.actualCost * (activity.writeRate / 100)) | toThousandNumFilter }}
                      </span>
                      <span v-else-if="scope.row.approveCost">
                        {{ scope.row.approveCost | toThousandNumFilter }}
                      </span>
                    </template>
                  </el-table-column> -->

                  <el-table-column prop="operateType" label="操作类型" />
                  <el-table-column prop="approveMsg" label="审核意见" />
                </el-table>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="提报审核历史">
            <div class="table">
              <el-table :data="findHistTasksData" border stripe style="width: 100%; margin: 0">
                <el-table-column prop="displayName" label="审核节点" />
                <el-table-column prop="operatorName" label="审核人" />
                <el-table-column prop="finishTime" label="审核时间" />
                <!--<el-table-column prop="amounts" label="申请费用(元)" align="right">
                  <template slot-scope="scope">
                    <span v-if="scope.row.amounts">{{ scope.row.amounts | toThousandNumFilter }}</span>
                  </template>
                </el-table-column>-->


                <el-table-column prop="approveCost" label="审核费用(元)" >
                  <template slot-scope="scope">
                    <span v-if="scope.row.approveCost">{{ scope.row.approveCost | toThousandNumFilter }}</span>
                  </template>
                </el-table-column>

            
                <el-table-column prop="operateType" label="操作类型" />
                <el-table-column prop="approveMsg" label="审核意见" />
              </el-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import { getActApplyDetail } from '@/api/actPlan.js'
export default {
  props: {
    findHistTasksData: {
      type: Array,
      default: () => []
    },
    writeoffTaskData: {
      type: Array,
      default: () => []
    },
    signData: {
      type: Object,
      default: () => ({})
    },
    activity: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      data: {
        marketactData: [],
        writeoffData: [],
        applyId: '',
        approveAppLoading: false,
        signDataChild: {}
      },
      activeNames: ['1']
    }
  },
  created() {
    // this.applyId = this.$route.params.id
    // this.getData()
          console.log(this.writeoffTaskData,'lulululu')
          console.log(JSON.stringify(this.writeoffTaskData),'lulululu')

  },
  methods: {
    async getData() {
      if (this.applyId) {
        getActApplyDetail(this.applyId).then(res => {
          console.log(res)
          if (res.code === 1 && res.data) {
            this.signDataChild = res.data.actPlanApply
            this.viewApproveDetail()
          }
        })
      }
    }
  }
}
</script>
<style lang="less">
.collapseItem1 {
  .el-collapse-item__header {
    padding: 0px 20px;
    width: 100%;
    margin: 0;
    background: #4489ce;
    color: #ffffff;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
  }
  .el-collapse-item__content {
    padding: 0;
  }
}
.collapse-box {
  margin-top: 10px;
  border: 1px solid #cccccc;
}
</style>
